/* eslint-disable no-nested-ternary */
import CounterInput from '@/atoms/forms/Counter';
import TextInput from '@/atoms/forms/Input';
import IconButton from '@/atoms/IconButton';
import Spinner from '@/atoms/loader/Spinner';
import CardThumb from '@/molecules/CardThumb';
import CustomMarkdown from '@/molecules/CustomMarkdown';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useFormatPrice } from 'hooks/i18n';
import { KYClimitToJSX } from 'hooks/useGetKYCLimit';
import { useTranslation } from 'next-i18next';
import { FormProvider } from 'react-hook-form';
import { SIZE, VARIANT_COLOR_ENUM } from 'types/utils';
import useManageOffer from './hooks';
import AlertTool from '@/molecules/AlertTool';
import { useFeatureFlag } from 'utils/ssr/middleware/hooks/useFeatureFlag';
import { PARAMS_KEYS } from 'utils/ssr/middleware/featureFlagMiddleware';

const ManageOffer = ({ reference, closeModal }: { reference: string; closeModal: () => void }) => {
  const { t } = useTranslation();
  const {
    formMethods,
    onSubmit,
    total,
    numberCopyAvailable,
    handleOpenModalOfferDeletion,
    isLoading,
    card,
    cardOffer,
    isLoadingCard,
    displayNetPrice,
  } = useManageOffer({
    closeModal,
    reference,
  });
  const { formatUserCurrency } = useFormatPrice();
  const isPaymentBlocked = useFeatureFlag(PARAMS_KEYS.PAYMENT_BLOCKED);

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isLoading={isLoading}
      isSubmitDisabled={isPaymentBlocked}
      onSubmit={onSubmit}
      submitLabel={isLoadingCard ? 'modal.cms.loading' : cardOffer ? t('edit-offer') : t('publish-offer')}
      title={isLoadingCard ? 'modal.cms.loading' : cardOffer ? 'edit-offer' : 'sell-copy'}
    >
      {card.stats?.isExclusive && (
        <AlertTool icon="fa-solid fa-circle-info" variant={VARIANT_COLOR_ENUM.INFO}>
          <CustomMarkdown className="p-0">{t('alert.exclusiveWarn')}</CustomMarkdown>
        </AlertTool>
      )}
      {isLoadingCard ? (
        <div className="flex justify-center">
          <Spinner size={SIZE.LG} />
        </div>
      ) : (
        <FormProvider {...formMethods}>
          <form className="flex flex-col gap-4" name="manage-offers" onSubmit={onSubmit}>
            <KYClimitToJSX />
            <div className="w-fit m-auto flex flex-col gap-4">
              <CardThumb
                alt=""
                imagePath={card.imagePath}
                inMyCollection={card.stats?.inMyCollection}
                inMySale={card.stats?.inMySale}
                isExclusive={!!card.stats?.isExclusive}
                isSuspended={card.isSuspended}
                numberCopyAvailable={card.stats?.numberCopyAvailable}
                size={SIZE.LG}
              />
              {typeof numberCopyAvailable === 'number' && (
                <CounterInput max={numberCopyAvailable} min={1} name="quantity" />
              )}
            </div>
            <div>
              <div className="flex items-end">
                <TextInput label="unit-price" name="price" step=".01" type="number" />
                {!!cardOffer && (
                  <IconButton icon="fa-solid fa-trash-can" onClick={handleOpenModalOfferDeletion} size={SIZE.MD} />
                )}
              </div>
              {!!displayNetPrice && (
                <div className="flex text-neutral-600 sm-medium ">
                  <CustomMarkdown>
                    {t('sell.operatingfees.estimate', { amount: formatUserCurrency(total) })}
                  </CustomMarkdown>
                </div>
              )}
            </div>
            <input className="hidden" type="submit" />
          </form>
        </FormProvider>
      )}
    </ModalClassicLayout>
  );
};

export default ManageOffer;
